import {
  FETCH_CAR_TYPES,
  FETCH_CAR_TYPES_SUCCESS,
  FETCH_CAR_TYPES_FAILED,
  EDIT_CAR_TYPE
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, set ,remove, push, update } from "firebase/database";
import { uploadBytes, uploadString, getDownloadURL } from "firebase/storage";

const guessImageContentType = (file) => {
  if (file?.type && file.type.startsWith('image/')) return file.type;
  const ext = (file?.name || '').split('.').pop()?.toLowerCase();
  const map = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    heic: 'image/heic',
    heif: 'image/heif',
    bmp: 'image/bmp',
  };
  return map[ext] || 'image/jpeg';
};

const readFileAsBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const result = reader.result;
    if (typeof result !== 'string') {
      reject(new Error('Invalid file read'));
      return;
    }
    const idx = result.indexOf('base64,');
    resolve(idx >= 0 ? result.slice(idx + 7) : result);
  };
  reader.onerror = () => reject(reader.error || new Error('File read failed'));
  reader.readAsDataURL(file);
});

const uploadCarTypeImage = async (storageRef, file) => {
  const metadata = { contentType: guessImageContentType(file) };
  try {
    await uploadBytes(storageRef, file, metadata);
  } catch (bytesError) {
    const base64 = await readFileAsBase64(file);
    await uploadString(storageRef, base64, 'base64', metadata);
  }
  return getDownloadURL(storageRef);
};

export const fetchCarTypes = () => (dispatch) => {

  const {
    carTypesRef
  } = firebase;

  dispatch({
    type: FETCH_CAR_TYPES,
    payload: null
  });
  onValue(carTypesRef, snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_CAR_TYPES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_CAR_TYPES_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_cars
      });
    }
  });
};

// Firebase Realtime DB lanza error si el objeto contiene valores `undefined`.
// Esto limpia esos valores (y descarta `tableData` que agrega MaterialTable).
const sanitizeForFirebase = (obj) => {
  if (obj === null || obj === undefined) return null;
  const clone = JSON.parse(JSON.stringify(obj, (key, value) => {
    if (key === 'tableData') return undefined;
    return value === undefined ? undefined : value;
  }));
  return clone;
};

export const editCarType = (cartype, method) => async (dispatch) => {
  const {
    carTypesRef, 
    carTypesEditRef,
    carDocImage
  } = firebase;
  dispatch({
    type: EDIT_CAR_TYPE,
    payload: { method, cartype }
  });
  if (method === 'Add') {
    push(carTypesRef, sanitizeForFirebase(cartype));
  } else if (method === 'Delete') {
    remove(carTypesEditRef(cartype.id));
  } else if (method === 'UpdateImage') {
    const { auth } = firebase;
    if (!auth?.currentUser) {
      throw new Error('storage/unauthenticated');
    }
    const id = cartype?.id;
    if (!id) {
      throw new Error('missing_cartype_id');
    }
    const file = cartype.image;
    if (!file) {
      throw new Error('no_image');
    }
    if (typeof file === 'string') {
      await update(carTypesEditRef(id), { image: file });
      return;
    }
    const imageUrl = await uploadCarTypeImage(carDocImage(id), file);
    await update(carTypesEditRef(id), { image: imageUrl });
  }
   else {
    set(carTypesEditRef(cartype.id), sanitizeForFirebase(cartype));
  }
}